import { useMemo } from "react";
import { useDeviceInfoQuery } from "@/hooks";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function OnlyAndroid(_ref) {
  var version = _ref.version,
      children = _ref.children;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      data = _useDeviceInfoQuery.data;

  var deviceInfo = data === null || data === void 0 ? void 0 : data.deviceInfo;
  var isAndroid = useMemo(function () {
    if (deviceInfo) {
      if (version) {
        return deviceInfo.isAndroid && deviceInfo.os.major <= version;
      } else {
        return deviceInfo.isAndroid;
      }
    }

    return false;
  }, [deviceInfo]);
  if (!isAndroid) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}